import { render, staticRenderFns } from "./vsPagination.vue?vue&type=template&id=0e72c8d8&"
import script from "./vsPagination.vue?vue&type=script&lang=js&"
export * from "./vsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports